(function () {
  'use strict';

  angular.module('eclipseApp.core')
    .directive('clickOutside', ['$document', '$parse', function ($document, $parse) {
      return {
        restrict: 'A',
        link: function (scope, element, attr) {
          var callback = $parse(attr.clickOutside);
          var documentClickHandler = function (event) {
            var eventOutsideTarget = (element[0] !== event.target) && (element.find(event.target).length === 0);
            if (eventOutsideTarget) {
              scope.$apply(function () {
                _.isFunction(callback) && callback(scope, {});
              });
            }
          };

          $document.on('click', documentClickHandler);
          scope.$on('$destroy', function () {
            $document.off('click', documentClickHandler);
          });
        }
      };
    }]);
})();
